import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

export enum InputStyle {
  Primary = 'Primary',
}

export enum InputHeight {
  Large = 'Large',
  Medium = 'Medium',
  Small = 'Small',
}

interface ITextInputProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  className?: string;
  inputHeight?: InputHeight;
  inputStyle?: InputStyle;
  label?: string;
  iconLeft?: any;
  innerRef?: any;
  rounded?: boolean;
}

export default function Input({
  className,
  inputStyle,
  inputHeight,
  label,
  iconLeft,
  innerRef,
  rounded = true,
  ...props
}: ITextInputProps) {
  const classes = twMerge(
    clsx('bg-transparent placeholder-primary text-primary focus:outline-none focus:ring-b-2 focus:ring-2 focus:border-white focus:ring-white px-4 py-2 w-full leading-tight',
      {
        'h-4 py-8 text-title-2': inputHeight === InputHeight.Large,
        'h-4 py-6 text-headline': inputHeight === InputHeight.Medium,
        'h-8 text-md': inputHeight === InputHeight.Small,
        'rounded-full': inputStyle === InputStyle.Primary,
        'pt-8 pb-2': !!label && inputHeight === InputHeight.Medium,
        'pl-16': !!iconLeft,
      }
    ),
    className
  );

  return (
    <div className={clsx('relative bg-darkglass', { 'rounded-full': rounded })}>
      {iconLeft && (
        <div className="absolute inset-y-0 left-0 flex items-center pl-6 pointer-events-none text-primary">
          {iconLeft}
        </div>
      )}
      {label && <p className="absolute text-primary text-xs pt-3 pl-4 uppercase">{label}</p>}
      <input {...props} ref={innerRef} className={classes} />
    </div>
  );
}
